class ProductBuyButtons extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    (this.button_container = this.querySelector(".product-buy-buttons--primary")),
      (this.floating_container = this.querySelector(".product-buy-buttons--floating")),
      (this.floating_button = this.querySelector(".product-buy-buttons--floating .product-buy-buttons--cta")),
      (this.floating_button_text = this.querySelector(".product-buy-buttons--floating .product-buy-buttons--cta-text")),
      (this.button_text = this.querySelector(".product-buy-buttons--primary .product-buy-buttons--cta-text")),
      (this.form = this.querySelector(".product-buy-buttons--form")),
      (this.quantity = 1),
      (this.select_input = this.querySelector(".product-buy-buttons--select")),
      (this.smart_button = this.querySelector(".product-buy-buttons--smart")),
      (this.primary_button = this.querySelector(".product-buy-buttons--primary .product-buy-buttons--cta")),
      (this.forceUpdate = this.dataset.forceUpdate == "true" ? true : false),
      (this.priority_processing_input = document.querySelector(".priority-checkbox-container input")),
      this.addToCartListener(),
      this.updateViewListener(),
      this.updateQuantityListener();
    if (this.floating_container) {
      this.scrollFloatingBtnListener();
    }
  }
  scrollFloatingBtnListener() {

    let observer;
    let options = {
      root: null, // viewport
      threshold: 0, // trigger callback when visibility passes this percentage
    };

    let callback = (entries, observer) => {
      entries.forEach(entry => {
        // If the on-page button is not in the viewport, show the floating button
        if (!entry.isIntersecting) {
          this.floating_container.style.display = 'block';
        } else {
          this.floating_container.style.display = 'none';
        }
      });
    };

    observer = new IntersectionObserver(callback, options);
    observer.observe(this.primary_button);

  }
  addToCartListener() {
    this.form.on("submit", async (event) => {
      // Priority Processing
      const pp_checkbox = this.priority_processing_input;

      const selectedOptionData = this.form.querySelector("option[selected]")["dataset"];
      const sellingPlanInput = this.form.querySelector('input[name="selling_plan"]');
      const quantity = theme.utils.getQuantity(this.dataset.id, selectedOptionData, this.quantity);
      const forceUpdate = this.forceUpdate;

      // Check if not using a drawer cart or if the quantity is valid
      if (("drawer" !== theme.settings.cart_type && quantity !== false) || (event.preventDefault(), event.stopPropagation()), quantity) {
        this.button_container.setAttribute("data-loading", true);
        if (this.floating_container && this.floating_container) {
          this.floating_container.setAttribute("data-loading", true);
        }

        if ("drawer" === theme.settings.cart_type) {
          try {
            const customColorInput = document.querySelector(".line-item-property__field input[name=pantone]");
            let customColor;
            if (customColorInput) {
              customColor = customColorInput.value;
            }
            await theme.cart.addItem(selectedOptionData.id, quantity, sellingPlanInput ? sellingPlanInput.value : null, forceUpdate, customColor);
            if (pp_checkbox && pp_checkbox.checked) {
              await theme.cart.addItem(pp_checkbox.value, 1, null, forceUpdate);
            }
            this.button_container.setAttribute("data-loading", false);
            if (this.floating_container && this.floating_container) {
              this.floating_container.setAttribute("data-loading", false);
            }
            document.documentElement.dispatchEvent(
              new CustomEvent('on:cart:change', { bubbles: true, cancelable: false, detail: { openDrawer: true } })
            );
          } catch (error) {
            this.button_container.setAttribute("data-loading", false);
            if (this.floating_container && this.floating_container) {
              this.floating_container.setAttribute("data-loading", false);
            }
            throw new Error(error);
          }
        }
      }
    });
  }
  updateViewListener() {
    window.on(`theme:product:${this.dataset.id}:variantChanged`, ({ detail: { variant, pfd_available } }) => {
      let selectedOption = this.select_input.querySelector("option[selected]");

      if (selectedOption) {
        selectedOption.removeAttribute("selected");
      }

      console.log(pfd_available);

      if (variant && variant.available && pfd_available) {
        this.selectVariant(variant.id);
        this.updateView(true, true);
      } else if (variant && (!variant.available || !pfd_available)) {
        this.selectVariant(variant.id);
        this.updateView(false, true);
      } else {
        this.updateView(false, false);
      }
    });
  }
  selectVariant(t) {
    let variantOption = this.select_input.querySelector(`option[value='${t}']`);

    if (variantOption) {
      variantOption.setAttribute("selected", true);
    }
  }
  updateView(available, variant) {
    if (available) {
      this.primary_button.removeAttribute("disabled");
      this.button_text.innerText = theme.translations.add_to_cart;
      if (this.floating_container && this.floating_container) {
        this.floating_button.removeAttribute("disabled");
        this.floating_button_text.innerText = theme.translations.add_to_cart;
      }

      if (this.smart_button) {
        this.smart_button.style.display = "block";
      }
    } else {
      this.primary_button.setAttribute("disabled", true);
      if (this.floating_container && this.floating_container) {
        this.floating_button.setAttribute("disabled", true);
      }

      if (this.smart_button) {
        this.smart_button.style.display = "none";
      }

      if (variant) {
        this.button_text.innerText = theme.translations.out_of_stock;
        if (this.floating_container && this.floating_container) {
          this.floating_button_text.innerText = theme.translations.out_of_stock;
        }
      } else {
        this.button_text.innerText = theme.translations.unavailable;
        if (this.floating_container && this.floating_container) {
          this.floating_button_text.innerText = theme.translations.unavailable;
        }
      }
    }
  }
  updateQuantityListener() {
    window.on(`theme:product:${this.dataset.id}:quantityChanged`, ({ detail: t }) => {
      this.quantity = t;
    });
  }
}
const productBuyButtonsEl = customElements.get("product-buy-buttons-root");
productBuyButtonsEl || customElements.define("product-buy-buttons-root", ProductBuyButtons);
